import { render, staticRenderFns } from "./DiagrammItem.vue?vue&type=template&id=63e9d734"
import script from "./DiagrammItem.vue?vue&type=script&lang=js"
export * from "./DiagrammItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports